"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertMessage = exports.alertColors = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const Target_1 = require("../Target");
exports.alertColors = {
    info: {
        backgroundColor: "notification03",
        borderColor: "notification01",
        icon: "info"
    },
    warning: {
        backgroundColor: "warning03",
        borderColor: "warning01",
        icon: "warning-circle"
    },
    success: {
        backgroundColor: "success03",
        borderColor: "success01",
        icon: "check-circle"
    },
    error: {
        backgroundColor: "error03",
        borderColor: "error01",
        icon: "x-circle"
    }
};
const AlertMessage = (props) => {
    const { variant = "info", header, content, onDismiss } = props;
    const alertStyles = exports.alertColors[variant];
    return (react_1.default.createElement(foundations_1.Box, { sx: {
            backgroundColor: alertStyles.backgroundColor,
            borderLeft: "8px solid",
            borderColor: alertStyles.borderColor,
            paddingInlineStart: 5,
            paddingInlineEnd: 5,
            paddingTop: 4,
            paddingBottom: 4,
            width: "100%",
            borderRadius: "small"
        } },
        react_1.default.createElement(foundations_1.Box, { sx: {
                display: "flex",
                alignItems: "start",
                justifyContent: "space-between",
                gap: 4
            } },
            react_1.default.createElement(foundations_1.Box, { sx: { display: "flex", flexDirection: "row", gap: 4 } },
                react_1.default.createElement(foundations_1.Icon, { sx: { color: alertStyles.borderColor }, icon: alertStyles.icon }),
                react_1.default.createElement(foundations_1.Box, { sx: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 2
                    } },
                    react_1.default.createElement(foundations_1.Text, { variant: "bold" }, header),
                    content)),
            onDismiss && (react_1.default.createElement(foundations_1.Box, { sx: { flexShrink: 0 } },
                react_1.default.createElement(Target_1.Target, { "aria-label": "Dismiss message", onClick: onDismiss },
                    react_1.default.createElement(foundations_1.Icon, { icon: "x", size: "sm", sx: { color: "stroke01" } })))))));
};
exports.AlertMessage = AlertMessage;
//# sourceMappingURL=AlertMessage.js.map